// Import only the algorithms used, not the whole crypto-js namespace. crypto-js is
// CommonJS and the default `import CryptoJS from 'crypto-js'` pulls in EVERY algorithm
// (~64KB, not tree-shakeable). These submodule imports ship only AES + HMAC-SHA256 (+ deps).
import AES from 'crypto-js/aes'
import HmacSHA256 from 'crypto-js/hmac-sha256'


/**
 * Encrypts a query string using AES-256 encryption
 * @param queryString - The URL query string to encrypt (e.g., "from=DXB&to=DEL&adults=1")
 * @returns Encrypted and URL-encoded string
 * @throws Error if encryption fails
 */
export const encryptQueryString = (queryString: string): string => {
    try {
        // Encrypt the query string using AES
        const encrypted = AES.encrypt(queryString, process.env.NEXT_PUBLIC_SEARCH_ENCRYPTION_KEY || "").toString()
        const signature = HmacSHA256(encrypted, process.env.NEXT_PUBLIC_SEARCH_ENCRYPTION_KEY || "").toString();
        // URL-safe encoding to handle special characters in encrypted string
        const encodedData = encodeURIComponent(encrypted);
        const encodedSignature = encodeURIComponent(signature);
        return `${encodedData}:${encodedSignature}`;
    } catch (error) {
        throw new Error('error occurred');
    }
}
